import React, {Component} from 'react';
import Menu from '../Menu/Menu';
import Info from '../Info/Info';
import Skills from '../Skills/Skills';

export default class Home extends Component {

    render() {
        return (
            <>
                <Menu></Menu>
                <Info></Info>
                <Skills></Skills>
            </>
        )
    }
}
